import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import Icon from "./Icon.js";
export default function MultiSelect({ options, value, onChange, placeholder, summary }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        function onDoc(e) {
            if (ref.current && !ref.current.contains(e.target))
                setOpen(false);
        }
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, []);
    const toggle = (v) => {
        if (value.includes(v))
            onChange(value.filter((x) => x !== v));
        else
            onChange([...value, v]);
    };
    const display = summary ? summary(value) :
        value.length === 0 ? _jsx("span", { className: "placeholder", children: placeholder }) :
            value.length === 1 ? options.find((o) => o.value === value[0])?.label :
                `${options.find((o) => o.value === value[0])?.label} +${value.length - 1}`;
    return (_jsxs("div", { className: "ms", ref: ref, children: [_jsxs("button", { type: "button", className: `ms__trigger ${open ? "is-open" : ""}`, onClick: () => setOpen((o) => !o), "aria-haspopup": "listbox", "aria-expanded": open, children: [_jsx("span", { style: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: display }), _jsx(Icon, { name: open ? "chevron-up" : "chevron-down", size: 12 })] }), open && (_jsx("div", { className: "ms__panel", role: "listbox", children: options.map((opt) => (_jsxs("button", { role: "option", "aria-selected": value.includes(opt.value), className: "ms__opt", onClick: () => toggle(opt.value), type: "button", children: [_jsx("span", { className: "chk" }), _jsx("span", { children: opt.label })] }, opt.value))) }))] }));
}
//# sourceMappingURL=MultiSelect.js.map